
import EventEmitter from 'events';
import ko from 'rgs-knockout';

export default class MyRgsLoginModel extends EventEmitter {
	constructor (options) {
		super();

		this.logContext = options.logContext;
		this.prefilling = options.prefilling;
		this.dictionaries = options.dictionaries;
		this.config = options.config;
		this.isPwaMode = options.isPwaMode;
		this.registrationMode = ko.observable(false);
	}
}
